const configElement = document.getElementById('store-config');
const config = configElement ? JSON.parse(configElement.textContent) : { variants: [], images: {}, root: '/', currency: 'ZAR' };
const $ = (selector, root = document) => root.querySelector(selector);
const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
const escapeHTML = value => String(value ?? '').replace(/[&<>"']/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char]);
const icon = name => `<svg class="icon" aria-hidden="true"><use href="#icon-${name}"></use></svg>`;
const endpoint = path => `${config.root.endsWith('/') ? config.root : `${config.root}/`}${path}`;
const announce = message => { const region = $('#store-announcement'); if (region) region.textContent = message; };
let currency = config.currency || 'ZAR';
const money = cents => currency === 'ZAR'
  ? new Intl.NumberFormat('en-ZA', { style: 'currency', currency, currencyDisplay: 'narrowSymbol', minimumFractionDigits: cents % 100 === 0 ? 0 : 2, maximumFractionDigits: 2 }).format(cents / 100).replace(/^R\s*/, 'R')
  : new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(cents / 100);
const quantity = value => Math.min(99, Math.max(1, Number.parseInt(value, 10) || 1));
const storageKey = 'pressur-bag-v1';
let previewItems = [];
let cart = { items: [], item_count: 0, total_price: 0 };
let cartBusy = false;
let cartRevision = 0;
let guideStep = 0;

function variantImage(variant) {
  if (variant?.image) return variant.image;
  const title = (variant?.title || '').toLowerCase();
  if (/black|obsidian/.test(title)) return config.images.obsidian;
  if (/orange/.test(title)) return config.images.orange;
  return config.images.sage;
}

function closeMenu() {
  const menu = $('#mobile-nav');
  if (menu) menu.hidden = true;
  const toggle = $('[data-menu-toggle]');
  if (toggle) { toggle.setAttribute('aria-expanded', 'false'); toggle.setAttribute('aria-label', 'Open navigation'); }
}

function openDialog(dialog) {
  if (!dialog) return;
  closeMenu();
  $$('dialog[open]').forEach(open => { if (open !== dialog) open.close(); });
  if (!dialog.open) dialog.showModal();
}

const policyTitles = { shipping: 'Shipping & delivery', returns: 'Returns & refunds', contact: 'Let’s talk.', privacy: 'Your privacy', terms: 'The terms', preview: 'Your reset is almost here.' };
function openPolicy(type) {
  const template = $(`#policy-${type}`);
  if (!template) return;
  $('#policy-title').textContent = policyTitles[type];
  $('[data-policy-content]').replaceChildren(template.content.cloneNode(true));
  openDialog($('#policy-dialog'));
  $('#policy-dialog').scrollTop = 0;
}

function changeGuide(step) {
  guideStep = Math.max(0, Math.min(2, step));
  $$('[data-guide-slide]').forEach(slide => { slide.hidden = Number(slide.dataset.guideSlide) !== guideStep; });
  $$('[data-guide-goto]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.guideGoto) === guideStep)));
  $('[data-guide-next]').innerHTML = `${guideStep === 2 ? 'Find your relief' : 'Next step'} ${icon('arrow')}`;
  announce(`Step ${guideStep + 1} of 3: ${['Position', 'Apply', 'Release'][guideStep]}`);
}

function selectAnatomy(name, focus = false) {
  $$('[data-anatomy-tab]').forEach(tab => {
    const selected = tab.dataset.anatomyTab === name;
    tab.setAttribute('aria-selected', String(selected));
    tab.tabIndex = selected ? 0 : -1;
    $(`#panel-${tab.dataset.anatomyTab}`).hidden = !selected;
    if (selected && focus) tab.focus();
  });
  $$('[data-anatomy-description]').forEach(panel => { panel.hidden = panel.dataset.anatomyDescription !== name; });
}

function selectImage(src, alt) {
  const image = $('#product-image');
  if (!image || !src) return;
  image.src = src;
  image.alt = alt;
}

function selectedVariant() {
  const id = $('#product-form input[name="id"]:checked')?.value;
  return config.variants.find(variant => String(variant.id) === String(id));
}

function updateVariant(id, updateUrl = true) {
  const variant = config.variants.find(item => String(item.id) === String(id));
  if (!variant) return;
  const input = $(`#product-form input[name="id"][value="${variant.id}"]`);
  if (input) input.checked = true;
  const title = $('[data-variant-name]');
  if (title) title.textContent = variant.title;
  $$('[data-product-price], [data-sticky-price]').forEach(element => { element.textContent = money(variant.price); });
  selectImage(input?.dataset.variantImage, `${config.productTitle} in ${variant.title}`);
  $$('#product-form button[type="submit"], [data-buy-now]').forEach(button => { button.disabled = !variant.available; });
  const label = $('[data-add-label]');
  if (label) label.textContent = variant.available ? 'Add to bag' : 'Sold out';
  if (updateUrl) {
    const url = new URL(location.href);
    url.searchParams.set('variant', variant.id);
    history.replaceState({}, '', url);
    announce(`${variant.title} selected, ${money(variant.price)}${variant.available ? '' : ', sold out'}`);
  }
}

function loadPreviewCart() {
  try {
    const stored = JSON.parse(localStorage.getItem(storageKey) || '[]');
    previewItems = Array.isArray(stored) ? stored.filter(item => item && config.variants.some(variant => String(variant.id) === String(item.id) && variant.available)).map(item => ({ id: item.id, quantity: quantity(item.quantity) })) : [];
  } catch { previewItems = []; }
  rebuildPreviewCart();
}

function rebuildPreviewCart() {
  cart.items = previewItems.map(item => {
    const variant = config.variants.find(variant => String(variant.id) === String(item.id));
    return { key: String(variant.id), id: variant.id, product_title: config.productTitle, variant_title: variant.title, quantity: item.quantity, final_line_price: variant.price * item.quantity, image: variantImage(variant) };
  });
  cart.item_count = cart.items.reduce((sum, item) => sum + item.quantity, 0);
  cart.total_price = cart.items.reduce((sum, item) => sum + item.final_line_price, 0);
  try { localStorage.setItem(storageKey, JSON.stringify(previewItems)); } catch { /* The in-memory bag remains usable when browser storage is disabled. */ }
  updateCounts();
}

async function request(path, options = {}) {
  const response = await fetch(endpoint(path), { ...options, credentials: 'same-origin', headers: { Accept: 'application/json', ...options.headers } });
  let data;
  try { data = await response.json(); } catch { throw new Error('We couldn’t reach the store. Please try again.'); }
  if (!response.ok) throw new Error(data.description || data.message || 'Something went wrong. Please try again.');
  return data;
}

async function refreshCart() {
  if (config.preview) { rebuildPreviewCart(); return; }
  const revision = ++cartRevision;
  const result = await request('cart.js');
  if (revision !== cartRevision) return;
  cart = result;
  if (cart.currency) currency = cart.currency;
  updateCounts();
}

function updateCounts() {
  $$('[data-cart-count]').forEach(element => { element.textContent = cart.item_count; });
  $$('[data-open-cart]').forEach(button => button.setAttribute('aria-label', `Open shopping bag, ${cart.item_count} ${cart.item_count === 1 ? 'item' : 'items'}`));
}

function renderCart() {
  const container = $('[data-cart-items]');
  if (!container) return;
  $('[data-cart-summary]').hidden = !cart.items.length;
  if (!cart.items.length) {
    container.innerHTML = `<div class="cart-empty">${icon('bag')}<h3>A little relief belongs here.</h3><p>Meet your new favourite part of the day. Your PRESSUR ONE is waiting.</p><button class="button button-primary" type="button" data-continue-shopping>Find your relief ${icon('arrow')}</button></div>`;
    return;
  }
  container.innerHTML = cart.items.map(item => `<article class="cart-line">
    <img class="cart-line-image" src="${escapeHTML(item.image || config.images.sage)}" alt="${escapeHTML(item.product_title)} — ${escapeHTML(item.variant_title)}" width="85" height="100">
    <div><div class="cart-line-heading"><h3>${escapeHTML(item.product_title)}</h3><span>${money(item.final_line_price ?? item.line_price)}</span></div>
    <p class="cart-line-variant">${escapeHTML(item.variant_title === 'Default Title' ? '' : item.variant_title)}</p>
    <div class="cart-line-bottom"><div class="cart-quantity"><button type="button" data-cart-change="${escapeHTML(item.key)}" data-next-quantity="${item.quantity - 1}" aria-label="Decrease ${escapeHTML(item.variant_title)} quantity">−</button><span aria-label="Quantity">${item.quantity}</span><button type="button" data-cart-change="${escapeHTML(item.key)}" data-next-quantity="${item.quantity + 1}" aria-label="Increase ${escapeHTML(item.variant_title)} quantity" ${item.quantity >= 99 ? 'disabled' : ''}>+</button></div><button type="button" class="cart-remove" data-cart-change="${escapeHTML(item.key)}" data-next-quantity="0" aria-label="Remove ${escapeHTML(item.product_title)} in ${escapeHTML(item.variant_title)}">Remove</button></div></div>
    </article>`).join('');
  $('[data-cart-subtotal]').textContent = money(cart.total_price);
}

function cartError(message = '') {
  const element = $('[data-cart-error]');
  element.hidden = !message;
  element.textContent = message;
}

async function openCart() {
  openDialog($('#cart-dialog'));
  cartError();
  if (cartBusy) { renderCart(); return; }
  $('[data-cart-items]').innerHTML = '<p class="cart-loading" role="status">Getting your bag ready…</p>';
  $('[data-cart-summary]').hidden = true;
  cartBusy = true;
  try { await refreshCart(); renderCart(); }
  catch (error) { renderCart(); cartError(error.message); }
  finally { cartBusy = false; }
}

async function changeCart(key, nextQuantity, trigger) {
  if (cartBusy) return;
  const next = Math.max(0, Math.min(99, nextQuantity));
  const action = trigger?.getAttribute('aria-label');
  cartBusy = true;
  cartRevision++;
  cartError();
  $$('[data-cart-change], [data-checkout]').forEach(button => { button.disabled = true; });
  try {
    if (config.preview) {
      previewItems = previewItems.map(item => String(item.id) === key ? { ...item, quantity: next } : item).filter(item => item.quantity > 0);
      rebuildPreviewCart();
    } else {
      cart = await request('cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: next }) });
      updateCounts();
    }
    renderCart();
    announce(`Bag updated. ${cart.item_count} items. Subtotal ${money(cart.total_price)}.`);
    const replacement = $$('[data-cart-change]').find(button => button.dataset.cartChange === key && button.getAttribute('aria-label') === action);
    (replacement || (cart.item_count ? $('[data-checkout]') : $('[data-continue-shopping]')))?.focus({ preventScroll: true });
  } catch (error) { cartError(error.message); renderCart(); }
  finally { cartBusy = false; const checkout = $('[data-checkout]'); if (checkout) checkout.disabled = false; }
}

async function addToCart(buyNow = false) {
  if (cartBusy) return;
  const variant = selectedVariant();
  if (!variant?.available) return;
  const quantityInput = $('#product-quantity');
  const count = quantity(quantityInput.value);
  quantityInput.value = count;
  const message = $('#product-message');
  const buttons = $$('#product-form button');
  const label = $('[data-add-label]');
  message.hidden = true;
  cartBusy = true;
  cartRevision++;
  let added = false;
  buttons.forEach(button => { button.disabled = true; });
  label.textContent = 'Adding…';
  try {
    if (config.preview) {
      const existing = previewItems.find(item => String(item.id) === String(variant.id));
      if (existing) existing.quantity = quantity(existing.quantity + count);
      else previewItems.push({ id: variant.id, quantity: count });
      rebuildPreviewCart();
    } else {
      await request('cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: variant.id, quantity: count }] }) });
      added = true;
      if (!buyNow) await refreshCart();
    }
    announce(`${count} ${config.productTitle} in ${variant.title} added to your bag.`);
    if (buyNow) {
      if (config.preview) openPolicy('preview');
      else window.location.assign(endpoint('checkout'));
    } else { renderCart(); cartError(); openDialog($('#cart-dialog')); }
  } catch (error) { message.textContent = added ? 'Added to your bag, but we couldn’t refresh it. Open your bag to try again.' : error.message; message.hidden = false; }
  finally { cartBusy = false; buttons.forEach(button => { button.disabled = false; }); label.textContent = 'Add to bag'; }
}

function goShopping() {
  $$('dialog[open]').forEach(dialog => dialog.close());
  const shop = $('#shop');
  if (shop) { shop.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' }); $('#product-title')?.setAttribute('tabindex', '-1'); $('#product-title')?.focus({ preventScroll: true }); }
  else location.assign(`${config.root}#shop`);
}

document.addEventListener('click', event => {
  const button = event.target.closest('button, a');
  if (!button) return;
  if (button.matches('[data-open-cart]')) openCart();
  if (button.matches('[data-close-dialog]')) button.closest('dialog')?.close();
  if (button.matches('[data-policy]')) openPolicy(button.dataset.policy);
  if (button.matches('[data-open-guide]')) { changeGuide(0); openDialog($('#guide-dialog')); }
  if (button.matches('[data-guide-goto]')) changeGuide(Number(button.dataset.guideGoto));
  if (button.matches('[data-guide-next]')) { if (guideStep < 2) changeGuide(guideStep + 1); else goShopping(); }
  if (button.matches('[data-anatomy-tab]')) selectAnatomy(button.dataset.anatomyTab);
  if (button.matches('[data-zoom-image]')) { const source = $('#product-image'); const target = $('[data-expanded-image]'); target.src = source.src; target.alt = source.alt; openDialog($('#image-dialog')); }
  if (button.matches('[data-quantity]')) { const input = $('#product-quantity'); input.value = quantity(quantity(input.value) + Number(button.dataset.quantity)); }
  if (button.matches('[data-buy-now]')) addToCart(true);
  if (button.matches('[data-cart-change]')) changeCart(button.dataset.cartChange, Number(button.dataset.nextQuantity), button);
  if (button.matches('[data-checkout]') && !cartBusy && cart.item_count > 0) { if (config.preview) openPolicy('preview'); else window.location.assign(endpoint('checkout')); }
  if (button.matches('[data-continue-shopping]')) goShopping();
  if (button.matches('[data-menu-toggle]')) {
    const menu = $('#mobile-nav');
    menu.hidden = !menu.hidden;
    button.setAttribute('aria-expanded', String(!menu.hidden));
    button.setAttribute('aria-label', menu.hidden ? 'Open navigation' : 'Close navigation');
  }
  if (button.closest('#mobile-nav') && button.tagName === 'A') closeMenu();
});

document.addEventListener('keydown', event => {
  if (event.key === 'Escape') closeMenu();
  if (event.target.matches('[data-anatomy-tab]') && ['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
    event.preventDefault();
    const name = event.key === 'Home' ? 'front' : event.key === 'End' ? 'back' : event.target.dataset.anatomyTab === 'front' ? 'back' : 'front';
    selectAnatomy(name, true);
  }
});

document.addEventListener('pointerdown', event => {
  if (!event.target.closest('.site-header')) closeMenu();
});
$$('dialog').forEach(dialog => {
  let startedOutside = false;
  dialog.addEventListener('pointerdown', event => { startedOutside = event.target === dialog && !insideDialog(event, dialog); });
  dialog.addEventListener('click', event => { if (startedOutside && event.target === dialog && !insideDialog(event, dialog)) dialog.close(); startedOutside = false; });
});
function insideDialog(event, dialog) {
  const box = dialog.getBoundingClientRect();
  return event.clientX >= box.left && event.clientX <= box.right && event.clientY >= box.top && event.clientY <= box.bottom;
}

$('#product-form')?.addEventListener('submit', event => { event.preventDefault(); addToCart(); });
$('#product-form')?.addEventListener('change', event => {
  if (event.target.name === 'id') updateVariant(event.target.value);
  if (event.target.name === 'quantity') event.target.value = quantity(event.target.value);
});

// Native details grouping keeps the accordion in sync for pointer and keyboard input.
$$('.faq-list details').forEach(details => details.setAttribute('name', 'storefront-faq'));

const initialVariant = new URLSearchParams(location.search).get('variant') || selectedVariant()?.id;
if (initialVariant) updateVariant(initialVariant, false);
if (config.preview) loadPreviewCart();
else refreshCart().catch(() => { /* Retry and display an actionable error when the bag is opened. */ });
window.addEventListener('storage', event => {
  if (config.preview && event.key === storageKey) { loadPreviewCart(); if ($('#cart-dialog')?.open) renderCart(); }
});

if ('IntersectionObserver' in window) {
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reducedMotion) {
    const revealObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.remove('awaiting-reveal'); revealObserver.unobserve(entry.target); } });
    }, { threshold: 0.06 });
    $$('[data-reveal]').forEach(element => {
      if (element.getBoundingClientRect().top > window.innerHeight) { element.classList.add('awaiting-reveal'); revealObserver.observe(element); }
    });
  }
  const stickyBar = $('[data-sticky-shop]');
  const hero = $('.hero');
  const shop = $('#shop');
  if (stickyBar && hero && shop) {
    let heroVisible = true;
    let shopVisible = false;
    const stickyObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => { if (entry.target === hero) heroVisible = entry.isIntersecting; if (entry.target === shop) shopVisible = entry.isIntersecting; });
      stickyBar.hidden = heroVisible || shopVisible;
    });
    stickyObserver.observe(hero);
    stickyObserver.observe(shop);
  }
}

window.addEventListener('pageshow', event => { if (event.persisted && !config.preview) refreshCart().then(renderCart).catch(() => {}); });
